/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ group: NonNullable<unknown> }} Checklist_Group_CollapseInputs */

const en_checklist_group_collapse = /** @type {(inputs: Checklist_Group_CollapseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hide ${i?.group}`)
};

const pt_br2_checklist_group_collapse = /** @type {(inputs: Checklist_Group_CollapseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ocultar ${i?.group}`)
};

/**
* | output |
* | --- |
* | "Hide {group}" |
*
* @param {Checklist_Group_CollapseInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const checklist_group_collapse = /** @type {((inputs: Checklist_Group_CollapseInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checklist_Group_CollapseInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checklist_group_collapse(inputs)
	return pt_br2_checklist_group_collapse(inputs)
});